import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./CourseWorkshop.css";

const courses = [
  {
    title: "BOARD EXAMS",
    description:
      "Standardized tests conducted by educational boards to assess students’ knowledge and skills, typically in 10th and 12th grades.",
    image: "/Assests/Board_Exam.png",
  },
  {
    title: "SDA",
    description:
      "Part of the selection process where candidates must clear the written test to qualify for positions.",
    image: "/Assests/Course_SDA.png",
  },
  {
    title: "NAVODAYA SCHOOL",
    description:
      "Conducted by CBSE, selects students based on their performance in the Jawahar Navodaya Vidyalaya Selection Test (JNVST) for Class VI1.",
    image: "/Assests/Course_Navodya.png",
  },
  {
    title: "SSC",
    description:
      "Part of the selection process where candidates must clear the written test to qualify for positions.",
    image: "/Assests/Schlorship.png",
  },
  {
    title: "MDRS (Morarje Desia)",
    description:
      "An annual entrance test for students in Karnataka seeking to enroll in educational programs offered by Morarji Desai schools.",
    image: "/Assests/Course_MDRS.png",
  },
  {
    title: "Sainik",
    description:
      "Prepares students to join the National Defence Academy and other officer training academies, with admissions offered at Class VI and Class IX based on exam performance.",
    image: "/Assests/Course_Sanik.png",
  },
  {
    title: "Reference Notes",
    description:
      "Reference notes pertain to works that have been directly cited or paraphrased, whereas a bibliography lists the works consulted.",
    image: "/Assests/reference.png",
  },
];

const workshops = [
  {
    title: "SOFT SKILLS",
    description:
      "Focuses on improving interpersonal skills, communication, and teamwork for better career opportunities.",
    image: "/Assests/Course_Hoop_Art.png",
  },
  {
    title: "PERSONALITY DEVELOPMENT",
    description:
      "Enhances overall personality through confidence-building exercises and professional grooming.",
    image: "/Assests/Workshop_Kids_Activity.png",
  },
  {
    title: "INTERVIEW SKILLS",
    description:
      "Prepares candidates for interviews with mock sessions, tips, and confidence-boosting exercises.",
    image: "/Assests/Workshop_Saree_Kuchu.png",
  },
  {
    title: "ROBOTICS WORKSHOPS",
    description:
      "Hey! Checkout this amazing course *Robotics Workshop * by Takshashila Gurukul.",
    image: "/Assests/workshop_robot.jpg",
  },
];

const CoursesAndWorkshops = () => {
  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">FREE COURSES WE OFFER</h2>
      <Carousel
        showThumbs={false}
        showStatus={false}
        showIndicators={false}
        infiniteLoop={false}
        autoPlay={false}
        centerMode
        centerSlidePercentage={33.33}
        swipeable
        emulateTouch
        renderArrowPrev={(onClickHandler, hasPrev, label) =>
          hasPrev && (
            <button
              type="button"
              className="carousel-arrow-prev"
              onClick={onClickHandler}
              aria-label={label}
            >
              ❮
            </button>
          )
        }
        renderArrowNext={(onClickHandler, hasNext, label) =>
          hasNext && (
            <button
              type="button"
              className="carousel-arrow-next"
              onClick={onClickHandler}
              aria-label={label}
            >
              ❯
            </button>
          )
        }
      >
        {courses.map((course, index) => (
          <div className="card-container" key={index}>
            <div className="card-flip">
              <div className="card-front">
                <img
                  src={course.image}
                  alt={course.title}
                  className="img-fluid"
                />
              </div>
              <div className="card-back">
                <h5>{course.title}</h5>
                <p>{course.description}</p>
              </div>
            </div>
          </div>
        ))}
      </Carousel>

      <h2 className="text-center mb-4 mt-5">WORKSHOPS WE OFFER</h2>
      <Carousel
        showThumbs={false}
        showStatus={false}
        showIndicators={false}
        infiniteLoop={false}
        autoPlay={false}
        centerMode
        centerSlidePercentage={33.33}
        swipeable
        emulateTouch
        renderArrowPrev={(onClickHandler, hasPrev, label) =>
          hasPrev && (
            <button
              type="button"
              className="carousel-arrow-prev"
              onClick={onClickHandler}
              aria-label={label}
            >
              ❮
            </button>
          )
        }
        renderArrowNext={(onClickHandler, hasNext, label) =>
          hasNext && (
            <button
              type="button"
              className="carousel-arrow-next"
              onClick={onClickHandler}
              aria-label={label}
            >
              ❯
            </button>
          )
        }
      >
        {workshops.map((workshop, index) => (
          <div className="card-container" key={index}>
            <div className="card-flip">
              <div className="card-front">
                <img
                  src={workshop.image}
                  alt={workshop.title}
                  className="img-fluid"
                />
              </div>
              <div className="card-back">
                <h5>{workshop.title}</h5>
                <p>{workshop.description}</p>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default CoursesAndWorkshops;
